<section class="gradient-section-theme-color1">
    <div class="container">
        <h1>
            {{product.name}}
        </h1>
    </div>
</section>

<section class="gradient-section-theme-color3">
    <div class="container">
        <div [innerHTML]="product.details"></div>
        <a class="product-link" [href]="product.link" target="_blank" rel="noopener noreferrer">
            Visit bunnycrm.com <span class="product-link-arrow" aria-hidden="true">↗</span>
        </a>
    </div>
</section>
